export const VerifyOTPAPI = async (phone, otp) => {
    try {

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}verify-otp`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                phone: phone,
                otp: otp
            })
        });

        if (!response.ok) {
            console.error(`Failed to send mail, status: ${response.status}`);
            return null;
        }

        // Attempt to parse JSON response
        const data = await response.json();

        return data;


    } catch (error) {
        console.error("Error sending mail:", error);
        return null;
    }
};
